import { useEffect, useState } from 'react';
import SearchComponent from './Filter/SearchComponent';
import { useAppContext } from '../../hooks/useAppContext';

const Navigation = () => {
  
  const [menuData, setMenuData] = useState([]);
  const { refreshMenu, menu } = useAppContext()

useEffect(() => {
 setMenuData(menu)
}, [menu])


  return (
    <div>
      <SearchComponent menu={menuData} />
    </div>
  )

};

export default Navigation; 